import React, { memo } from "react";
import { Helmet } from "react-helmet";

import { AuthenticationLayout } from "layouts";
import { AuthenticationBox } from "components";

const LogIn = () => {
	const title = process.env.REACT_APP_TITLE || "Ugenie";

	return (
		<AuthenticationLayout>
			<Helmet>
				<title>{title}</title>
			</Helmet>
			<AuthenticationBox />
		</AuthenticationLayout>
	);
};

export default memo(LogIn);
